import { Show } from "solid-js";
import { useI18n } from "../i18n/provider.tsx";
import { bandFor, bandLabel, formatScore } from "../lib/format.ts";
import type { ServerBand } from "../api/domain.ts";
import styles from "./Band.module.scss";

export type BandProps = {
  /** Undefined or null means the entity has no scored question yet. */
  score?: number | null;
  /** The band the server already derived; it wins over the local thresholds. */
  band?: ServerBand | null;
  showScore?: boolean;
};

/** Renders a score as its display band, or as "not assessed" when there is none. */
export const Band = (props: BandProps) => {
  const i18n = useI18n();
  const band = () => bandFor(props.score ?? null, props.band ?? null);
  const label = () => {
    const current = band();
    return current === undefined ? i18n.t().common.notAssessed : bandLabel(i18n.t(), current);
  };

  return (
    <span class={`${styles.badge} ${styles[band() ?? "unassessed"]}`}>
      <span class={styles.dot} aria-hidden="true" />
      {label()}
      <Show when={props.showScore === true && props.score !== undefined && props.score !== null}>
        <span>{formatScore(props.score ?? 0, i18n.locale())}</span>
      </Show>
    </span>
  );
};
